import {useEffect, useRef} from "react";

export function useDebounce<T>(callback: (...args: T[]) => void, wait: number) {
    const timerRef = useRef<number | NodeJS.Timeout | undefined>(undefined);

    const debouncedFunction = (...args: T[]) => {
        if (timerRef.current !== undefined) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            callback(...args);
        }, wait);
    };

    const cancel = () => {
        if (timerRef.current !== undefined) {
            clearTimeout(timerRef.current);
        }
    };

    useEffect(() => {
        return () => {
            cancel();
        };
    }, []);

    return {debounce: debouncedFunction, cancel};
}